import React from 'react';

export default () => <i className="Icon Icon-spinner Icon--spin" />;
